module.exports = __webpack_public_path__ + "assets/img/appointment-section-back.1662c765.png";